import InfoBlock from './InfoBlock'

export { InfoBlock }
export default InfoBlock
